import React from 'react';
import { Database, ChevronDown, ChevronUp, Monitor as ScreenIcon } from 'lucide-react';
import { Button } from '../ui/button';

const ModulosSection = ({ modulos, activeModuleScreens, setActiveModuleScreens }) => (
  <article className="mb-16" aria-labelledby="modulos-title">
    <h2 id="modulos-title" className="text-2xl font-bold text-white text-center mb-8">
      <Database className="w-6 h-6 inline mr-2 text-cyan-400" />
      Módulos do Sistema
    </h2>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {modulos.map(modulo => {
        const Icon = modulo.icon;
        return (
          <article key={modulo.id}
            className="bg-slate-800/60 border border-slate-700/50 rounded-xl overflow-hidden hover:border-cyan-500/50 transition-all group"
            itemScope itemType="https://schema.org/SoftwareApplication">
            <div className={`bg-gradient-to-r ${modulo.color} p-4`}>
              <div className="flex items-center gap-3">
                <Icon className="w-8 h-8 text-white" />
                <h3 className="text-lg font-bold text-white" itemProp="name">{modulo.title}</h3>
              </div>
            </div>
            <div className="p-5">
              <p className="text-gray-300 text-sm mb-4" itemProp="description">{modulo.description}</p>
              <Button onClick={() => setActiveModuleScreens(activeModuleScreens === modulo.id ? null : modulo.id)}
                variant="outline" size="sm" className="w-full border-cyan-500/50 text-cyan-400 hover:bg-cyan-500/10"
                aria-expanded={activeModuleScreens === modulo.id}>
                <ScreenIcon className="w-4 h-4 mr-2" />
                {activeModuleScreens === modulo.id ? 'Ocultar Telas' : 'Ver Telas'}
                {activeModuleScreens === modulo.id ? <ChevronUp className="w-4 h-4 ml-2" /> : <ChevronDown className="w-4 h-4 ml-2" />}
              </Button>
              {activeModuleScreens === modulo.id && (
                <div className="mt-4 space-y-3 animate-in slide-in-from-top-2 duration-300">
                  {modulo.screens.map((screen, idx) => (
                    <div key={idx} className="bg-slate-900/50 rounded-lg p-3 border border-slate-700/50">
                      <p className="text-sm text-cyan-400 font-medium mb-2">{screen.title}</p>
                      <div className="bg-slate-800 rounded-lg overflow-hidden">
                        <img src={screen.img} alt={`${modulo.title} - ${screen.title}`}
                          className="w-full h-auto opacity-90 hover:opacity-100 transition-opacity cursor-pointer"
                          loading="lazy"
                          onError={e => { e.target.style.display = 'none'; }} />
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </article>
        );
      })}
    </div>
  </article>
);

export default ModulosSection;
